<template>
    <div class="bgView" :style="{fontSize:fontsize,width:screenWidth}" id="areaCockpit">
        <div class="bk" :style="{fontSize:fontsize,width:screenWidth}">

            <div class="bg" :style="{fontSize:fontsize,width:screenWidth}">
                <div :style="{width:viewWidth,height:viewHeight,backgroundImage:'url('+biankuangBg+')'}"
                     class="containerView">

                    <!--顶部按钮区 start-->
                    <div class="operationView font-weight-bold">
                        <div class="flex-view-style j-c-f"
                             style="height:100%;">

                            <div class="helloView c-pointer d-flex justify-center align-center">
                                {{acctName}}，{{timeStr}}
                            </div>


                            <v-menu dark bottom offset-y>
                                <template v-slot:activator="{ on }">

                                    <div v-on="on"
                                         class="workBench c-pointer d-flex justify-center align-center">
                                    </div>

                                </template>

                                <!--<v-list style="background-color:#012E7B;margin-top:10px;">-->
                                <v-list style="margin-top:10px;">
                                    <v-list-item
                                            v-for="(item, index) in routers"
                                            :key="item.name"
                                            @click="changeMenu(item)"
                                    >
                                        <v-list-item-title>{{ item.meta.title }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>

                            </v-menu>

                        </div>

                        <div class="flex-view-style j-c-f">
                            <v-menu dark
                                    :close-on-content-click="false"
                                    v-model="isShowTypeList"
                                    bottom
                                    offset-y>

                                <template v-slot:activator="{ on }">

                                    <!--查找医院设备-->
                                    <div v-on="on">
                                        <div class="chooseTypeView selectHospital c-pointer d-flex justify-flex-start align-center">
                                            <img style="width:1.5em;height:1.5em;margin-right:0.5em;"
                                                 src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/sousuo.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=1001753349341&Signature=0trzQ9SDqiuz5P%2BrovhmghwvFNk%3D"
                                                 alt="">
                                            <input disabled
                                                   autocomplete="off"
                                                   class="selectEqpNameClass"
                                                   v-model="selectEqpName"
                                                   type="text" placeholder="设备名称">
                                        </div>
                                    </div>

                                </template>

                                <v-list style="margin-top:10px;">

                                    <v-list-item>
                                        <v-text-field
                                                v-model="searchKeyValue"
                                                append-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                        ></v-text-field>
                                    </v-list-item>

                                    <div v-if="searchTypeList.length>0"
                                         class="listView"
                                         style="max-height: 80vh;overflow-y: auto">
                                        <v-list-item>
                                            <v-list-item-title @click="showAll"
                                                               style="font-size:0.9em;cursor:pointer">
                                                全部
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                                @click="chooseTypeValue(item)"
                                                v-for="(item, index) in searchTypeList"
                                                :key="index">
                                            <v-list-item-title style="font-size:0.9em;">{{item}}
                                            </v-list-item-title>
                                        </v-list-item>
                                    </div>
                                    <div v-else>
                                        <v-list-item>
                                            <v-list-item-title style="font-size:0.9em;">无匹配数据
                                            </v-list-item-title>
                                        </v-list-item>
                                    </div>
                                </v-list>
                            </v-menu>
                        </div>

                    </div>
                    <!--顶部按钮区 end-->


                    <!--底部内容區域 start-->
                    <div class="bottomDiv">

                        <div class="bottom_left">

                            <!--共享设备总数 start-->
                            <div class="shareEqpSum d-flex justify-space-between align-center">
                                <div class="d-flex flex-column align-start justify-center">
                                    <div class="font-weight-bold" style="font-size:2em;">{{shareEqpSum}}</div>
                                    <div>共享设备总数</div>
                                </div>
                                <z-echarts-percentage :index="0" title="空闲" color="#11E9AA" :percent="overView.freeNum"
                                                      style="width:22%;"></z-echarts-percentage>
                                <z-echarts-percentage :index="1" title="借出" color="#03D4EC" :percent="overView.lendNum"
                                                      style="width:22%;"></z-echarts-percentage>
                                <z-echarts-percentage :index="2" title="故障" color="#FFA200" :percent="overView.faultNum"
                                                      style="width:22%;"></z-echarts-percentage>
                            </div>
                            <!--共享设备总数 end-->

                            <!--共享设备排行 start-->
                            <div class="rankingView">
                                <div style="font-size:1.2em;">设备共享排行</div>
                                <div style="color:#A5A5A5;margin-top:0.2em;margin-bottom:0.2em;">Device sharing</div>
                                <div class="d-flex justify-space-between"
                                     style="color:#A2C1FF;margin-bottom:0.1em;">
                                    <span style="width:30%;">设备名称</span>
                                    <span style="width:10%;">数量</span>
                                    <span style="width:10%;">空闲</span>
                                    <span style="width:10%;">借出</span>
                                    <span style="width:10%;">故障</span>
                                </div>

                                <div style="height:70%;">
                                    <z-scroll-component :classStr="0" ref="shareRankingViewScroll">
                                        <div class="flex-view-style scrollItem rankingViewItem"
                                             style="cursor:pointer"
                                             v-for="(item,index) in rankingShareEqpList"
                                             :key="index"
                                             @click="toAssetsManage(item)">
                                            <span style="width:30%;">{{item.assetsName}}</span>
                                            <span style="width:10%;">{{item.assetsTotal}}</span>
                                            <span style="width:10%;">{{item.assetsFreeCount}}</span>
                                            <span style="width:10%;">{{item.assetsBorrowCount}}</span>
                                            <span style="width:10%;">{{item.assetsFaultCount}}</span>
                                        </div>
                                    </z-scroll-component>
                                </div>
                            </div>
                            <!--共享设备排行 end-->

                            <!--设备使用时间排行 start-->
                            <div class="timeRankingView">
                                <div style="font-size:1.2em;">设备使用时间排行</div>
                                <div style="color:#A5A5A5;margin-top:0.2em;margin-bottom:0.2em;">Usage time ranking
                                </div>
                                <div style="height:78%;">
                                    <z-scroll-component :classStr="1" ref="rankingViewScroll">
                                        <div class="flex-view-style scrollItem"
                                             style="cursor:pointer"
                                             v-for="(item,index) in rankingViewList"
                                             :key="index"
                                             @click="toRecordQuery(item)">
                                            <span>
                                                <span class="indexViewStyle">NO.{{index+1}}</span>
                                                <span>{{item.assetsName}}</span>
                                            </span>
                                            <span style="color: #00d2ff;padding-right:0.5em;">
                                                <span class="font-weight-bold" style="font-size:1.2em;">{{item.useTimeTotal}}</span>
                                                <span>小时</span>
                                            </span>
                                        </div>
                                    </z-scroll-component>
                                </div>
                            </div>
                            <!--设备使用时间排行 end-->

                        </div>

                        <div class="bottom_center">

                            <div class="bottom_center_bg">
                                <img src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/sbwh.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=1001753349374&Signature=P9KTQGPjvo0F%2FgGtx53AIWTnOMw%3D"
                                     alt="">
                            </div>

                            <!--<div class="bottom_center_bg">-->
                            <!--</div>-->

                            <!--科室展示模块  start-->
                            <div class="officeShowView">
                                <v-carousel
                                        height="100%"
                                        show-arrows-on-hover
                                        hide-delimiters
                                        hide-delimiter-background
                                        :show-arrows="officeList.length>9?true:false"
                                >
                                    <v-carousel-item
                                            v-for="(slide, index) in (officeList.length%9==0)?(officeList.length/9):(parseInt(officeList.length/9)+1)"
                                            :key="index">

                                        <div class="fill-height d-flex justify-start align-start"
                                             style="flex-wrap:wrap;">

                                            <div style="width:33.3%;"
                                                 v-for="(item,key) in (index+1)==((officeList.length%9==0)?(officeList.length/9):(parseInt(officeList.length/9)+1))?(officeList.length%9==0?9:officeList.length%9):9"
                                                 :key="key">
                                                <div class="officeItem">
                                                    <div class="officeItem_topLeft">
                                                        <div>{{officeList[(index*6)+key].deptName}}</div>
                                                        <div style="font-size:0.8em;">
                                                            {{officeList[(index*6)+key].deptLocation}}
                                                        </div>
                                                    </div>
                                                    <div class="officeItem_topRight">
                                                        <span style="font-size:1.5em;margin-left:0.5em;">{{officeList[(index*6)+key].deptAssetsCount}}</span>
                                                        <span>台</span>
                                                    </div>
                                                    <div class="d-flex justify-space-between officeItem_bottom"
                                                         style="cursor:pointer" @click="toAssetsManage(officeList[(index*6)+key])">
                                                        <div class="numView d-flex flex-column align-center justify-center">
                                                            <div>{{officeList[(index*6)+key].deptFreeAssetsCount}}</div>
                                                            <div>空闲</div>
                                                        </div>
                                                        <div class="numView lend d-flex flex-column align-center justify-center"
                                                             style="position:relative;top:2em;">
                                                            <div>{{officeList[(index*6)+key].deptBorrowAssetsCount}}
                                                            </div>
                                                            <div>借出</div>
                                                        </div>
                                                        <div class="numView fault d-flex flex-column align-center justify-center">
                                                            <div>{{officeList[(index*6)+key].deptFaultAssetsCount}}
                                                            </div>
                                                            <div>故障</div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>


                                        </div>

                                    </v-carousel-item>
                                </v-carousel>
                            </div>
                            <!--科室展示模块  end-->

                            <div class="typeListView"
                                 ref="typeListView"
                                 draggable="false"
                                 @mouseenter="mousemoveView"
                                 @mousedown="returnFalse">
                                <div class="album"
                                     ref="album"
                                     @mousedown="returnFalse">
                                    <div @click="clickScrollItem(index)"
                                         :class="index==current3DView&&!isAll?'scroll3dView scroll3dViewCurrent d-flex align-center justify-center':'scroll3dView d-flex align-center justify-center'"
                                         v-for="(item,index) in scrollTypeList"
                                         :key="index">
                                        {{item}}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="bottom_right">
                            <!--逾期未归还 start-->
                            <div class="overdueView">

                                <div class="d-flex justify-space-between"
                                     style="margin-bottom:0.5em;">
                                    <div>
                                        <div class="titleStyle">逾期未归还</div>
                                        <div style="color:#A5A5A5;margin-top:0.2em;margin-bottom:0.2em;">
                                            Be overdue
                                        </div>
                                    </div>
                                    <div class="d-flex align-center justify-space-between overdueNum">
                                        <div>未归还数</div>
                                        <div>{{overdueEqpList.length}}台</div>
                                    </div>
                                </div>

                                <div style="height:80%;">
                                    <z-scroll-component :classStr="2" ref="overdueViewScroll">
                                        <div class="d-flex flex-column scrollItem"
                                             v-for="(item,index) in overdueEqpList"
                                             :key="index">
                                            <div class="d-flex justify-space-between">
                                                <div>
                                                    <div class="d-flex">
                                                        <div>领用：</div>
                                                        <div>
                                                            <span>{{item.receiverDept}}</span>
                                                            <span style="margin-left:1em;">{{item.receiverPerson}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex">
                                                        <div>借出：</div>
                                                        <div>
                                                            <span>{{item.borrowTime}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex" style="color:#FFA800;">
                                                        <div>应还：</div>
                                                        <div>
                                                            <span>{{item.shouldReturnTime}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-center justify-end keyTimeView"
                                                     style="font-size:1.2em;">
                                                    <span>逾期</span>
                                                    <span style="font-size:1.2em;margin:0 0.5em;">{{item.overdueDays}}</span>
                                                    <span>天</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-space-between">
                                                <div style="color:#00D2FF;font-size:1.1em;">{{item.receiverDept}}</div>
                                                <div style="width:30%;"
                                                     class="d-flex justify-space-between">
                                                    <span>{{item.assetsBrand}}</span>
                                                    <span>{{item.assetsModel}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </z-scroll-component>
                                </div>
                            </div>
                            <!--逾期未归还 end-->

                            <!--实时借出记录 start-->
                            <div class="realTimeView">

                                <div class="d-flex justify-space-between"
                                     style="margin-bottom:0.5em;">
                                    <div>
                                        <div class="titleStyle">实时借出记录</div>
                                        <div style="color:#A5A5A5;margin-top:0.2em;margin-bottom:0.2em;">
                                            Lending record
                                        </div>
                                    </div>
                                </div>

                                <div style="height:80%;">
                                    <z-scroll-component :classStr="3" ref="realTimeViewScroll">
                                        <div class="d-flex flex-column scrollItem"
                                             v-for="(item,index) in realTimeList" :key="index">
                                            <div class="d-flex justify-space-between">
                                                <div>
                                                    <div class="d-flex">
                                                        <div style="flex-shrink: 0">领用：</div>
                                                        <div>
                                                            <span>{{item.receiverDept}}</span>
                                                            <span style="margin-left:1em;">{{item.receiverPerson}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex">
                                                        <div>借出：</div>
                                                        <div>
                                                            <span>{{item.borrowTime}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-center justify-end keyTimeView"
                                                     style="font-size:1.2em;">
                                                    <span>借期</span>
                                                    <span style="font-size:1.2em;margin:0 0.5em;">{{item.borrowDays}}</span>
                                                    <span>天</span>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-space-between">
                                                <div style="color:#00D2FF;font-size:1.1em;">{{item.assetsName}}</div>
                                                <div class="d-flex justify-end">
                                                    <span style="margin-right:15px;">{{item.assetsBrand}}</span>
                                                    <span>{{item.assetsModel}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </z-scroll-component>
                                </div>
                            </div>
                            <!--实时借出记录 end-->
                        </div>
                    </div>
                    <!--底部内容區域 end-->
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import ZScrollComponent from "@/components/ZScrollComponent"
  import Vue from 'vue'
  import ZMenu from "@/components/ZMenu"
  import {getTime} from "@/utils/getTime"
  import {mapGetters} from 'vuex'
  import ZSetUp from "@/components/ZSetUp"
  import ZEchartsPercentage from "@/components/ZEchartsPercentage"
  import {
    assetsTotal,
    assetsNameTotal,
    assetsUseTimeRank,
    assetsSort,
    deptAssetsDistribute,
    overdueReturnQuery,
    realBorrowRecordQuery
  } from '@/api/dataPlatform'

  export default {
    name: 'DataPlatform',
    data() {
      return {
        biankuangBg: "",
        selectEqpName: '',
        isShowTypeList: false,
        searchKeyValue: '',
        current3DView: 0,
        isAll: false,
        shareEqpSum: 0,
        overView: {
          freeNum: 0,
          lendNum: 0,
          faultNum: 0
        },
        officeList: [],
        scrollTypeList: [],
        searchTypeList: [],
        allEqpNameTypeList: [],
        rankingShareEqpList: [],
        rankingViewList: [],
        viewWidth: '',
        viewHeight: '',
        screenWidth: '',
        fontsize: '',
        timeStr: '',
        unitDeg: 0,
        time: 0,
        opacityList: [],
        scrollInterval: null,
        overdueEqpList: [],
        realTimeList: [],
        bgTimeInterval: null
      }
    },
    components: {
      ZScrollComponent,
      ZMenu,
      ZSetUp,
      ZEchartsPercentage
    },
    watch: {
      searchKeyValue(newValue, oldValue) {
        if (newValue) {
          this.searchTypeList = [];
          for (var i = 0; i < this.allEqpNameTypeList.length; i++) {
            if (this.allEqpNameTypeList[i].indexOf(newValue) != -1) {
              this.searchTypeList.push(this.allEqpNameTypeList[i])
            }
          }
        } else {
          this.searchTypeList = this.allEqpNameTypeList;
        }
      },
      current3DView(newValue, oldValue) {
        if (this.scrollTypeList[newValue]) {
          this.selectEqpName = this.scrollTypeList[newValue];
        }
        this.getDeptAssetsDistribute(this.selectEqpName);
      }
    },
    computed: {
      ...mapGetters([
        'routers',
        'acctName'
      ]),
    },
    methods: {
      clickScrollItem(index) {
        clearInterval(this.scrollInterval);
        this.isAll = false;

        var step = 0;
        var isAdd = true;

        if (Math.abs(index - this.current3DView) > (this.scrollTypeList.length / 2)) {
          step = this.scrollTypeList.length - Math.abs(index - this.current3DView);
        } else {
          step = Math.abs(index - this.current3DView);
        }

        if (Math.abs(index - this.current3DView) <= (this.scrollTypeList.length / 2) && index > this.current3DView) {
          isAdd = false;
        } else if (Math.abs(index - this.current3DView) > (this.scrollTypeList.length / 2) && index < this.current3DView) {
          isAdd = false
        } else {
          isAdd = true;
        }

        if (isAdd) {
          this.time = parseInt(this.time + step);
          for (var i = 0; i < step; i++) {
            this.opacityList = this.opacityList.slice(1, this.opacityList.length).concat(this.opacityList[0]);
          }
        } else {
          this.time = parseInt(this.time - step);
          for (var i = 0; i < step; i++) {
            this.opacityList = this.opacityList.slice(this.opacityList.length - 1, this.opacityList.length).concat(this.opacityList.slice(0, this.opacityList.length - 1));
          }
        }

        this.current3DView = index;
        var album = this.$refs.album;
        album.style.transform = `rotateX(-11deg) rotateY(${this.unitDeg * this.time}deg)`;

        var imgs = this.$refs.album.children;
        Array.prototype.forEach.call(imgs, (it, i, arr) => {
          it.style.opacity = `${this.opacityList[i]}`;
        })

      },
      showAll() {
        clearInterval(this.scrollInterval);
        this.selectEqpName = '全部';
        this.isAll = true;
        this.isShowTypeList = false;

        this.getDeptAssetsDistribute();

      },
      // 指定转动位置
      chooseTypeValue(item) {
        this.isAll = false;
        this.isShowTypeList = false;
        clearInterval(this.scrollInterval);
        // 转盘最多容纳26个类型循环展示
        // 当类型超过26个时，类型下拉框展示所有类型，下拉框选择某个类型切换时，重新渲染转盘，26个数据为所选择类型周围的26个数据

        this.selectEqpName = item;
        this.searchKeyValue = '';

        var num = '';
        for (var i = 0; i < this.allEqpNameTypeList.length; i++) {
          if (item == this.allEqpNameTypeList[i]) {
            num = i;
          }
        }

        if (this.allEqpNameTypeList.length > 26) {
          // 假如长度超过26特殊处理，因为转盘最多不能超过26
          if ((num + 26) > this.allEqpNameTypeList.length) {
            this.scrollTypeList = this.allEqpNameTypeList.slice(this.allEqpNameTypeList.length - 26, num).concat(this.allEqpNameTypeList.slice(num, this.allEqpNameTypeList.length));
            this.initScroll();
            this.$nextTick(() => {
              this.time = -(num - (this.allEqpNameTypeList.length - 26));
              this.current3DView = num - (this.allEqpNameTypeList.length - 26);
              var album = this.$refs.album;
              album.style.transform = `rotateX(-11deg) rotateY(${this.unitDeg * this.time}deg)`;
              for (var i = 0; i < Math.abs(this.time); i++) {
                this.opacityList = this.opacityList.slice(this.opacityList.length - 1, this.opacityList.length).concat(this.opacityList.slice(0, this.opacityList.length - 1));
              }
              var imgs = this.$refs.album.children;
              Array.prototype.forEach.call(imgs, (it, i, arr) => {
                it.style.opacity = `${this.opacityList[i]}`;
              })
            });
          } else if ((num + 26) <= this.allEqpNameTypeList.length) {
            this.scrollTypeList = this.allEqpNameTypeList.slice(num, num + 26);
            this.initScroll();
          }
        } else {
          this.initScroll();
          this.$nextTick(() => {
            var album = this.$refs.album;
            this.time = -num;
            this.current3DView = num;
            album.style.transform = `rotateX(-11deg) rotateY(${this.unitDeg * this.time}deg)`;
            for (var i = 0; i < num; i++) {
              this.opacityList = this.opacityList.slice(this.opacityList.length - 1, this.opacityList.length).concat(this.opacityList.slice(0, this.opacityList.length - 1));
            }
            var imgs = this.$refs.album.children;
            Array.prototype.forEach.call(imgs, (it, i, arr) => {
              it.style.opacity = `${this.opacityList[i]}`;
            })
          });
        }


        console.log(this.scrollTypeList, 'this.scrollTypeList');

      },
      returnFalse(e) {
        e.preventDefault();
      },
      goPCWeb() {
        window.location.href = "http://hosp.zzitec.com";
      },
      changeMenu(item) {
        this.$store.dispatch('setCurretTitle', item.meta.title);
        this.$router.push({path: item.path});
      },
      resizePage() {
        var x = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        var y = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        console.log(x, '宽')
        console.log(y, '高')
        this.screenWidth = x + 'px'
        var val = parseFloat((x / y).toFixed(1))
        console.log(val, '比例')
        if (val < 1.78) {
          console.log('宽为准')
          // 以宽为准
          this.viewWidth = x + 'px'
          this.viewHeight = parseInt(x / (1.78)) + 'px'
          this.fontsize = parseInt(x / (1920 / 16)) + 'px'
        } else {
          console.log('高为准');
          // 以高为准
          this.viewHeight = '100%';
          this.viewWidth = parseInt(y * 1.77) + 'px';
          this.fontsize = parseInt((y * 1.77) / (1920 / 16)) + 'px';
        }
        this.viewWidth = x + 'px';
        this.viewHeight = y + 'px';

        this.$nextTick(() => {
          this.initPage();
        });
      },
      // 更新页面
      initPage() {
        this.getAssetsTotal();
        this.getAssetsNameTotal();
        this.getAssetsUseTimeRank();
        this.getEqpNameList();
        this.getOverdueReturnQuery();
        this.getRealBorrowRecordQuery();
      },
      // 获取逾期未归还数据
      getOverdueReturnQuery(){
        overdueReturnQuery({}).then(res => {
            this.overdueEqpList=res;
            this.$refs.overdueViewScroll.ScrollUp();
        }).catch(err => {

        })
      },
      // 实时借出记录
      getRealBorrowRecordQuery(){
        realBorrowRecordQuery({}).then(res => {
          this.realTimeList=res;
          this.$refs.realTimeViewScroll.ScrollUp();
        }).catch(err => {

        })
      },
      // 获取设备名称列表
      getEqpNameList() {
        // 获取转盘数据 最长26
        assetsSort({}).then(res => {
          this.allEqpNameTypeList=[];
          for(var i=0;i<res.length;i++){
            this.allEqpNameTypeList.push(res[i].assetsName);
          }
          // this.allEqpNameTypeList = res;
          if (this.allEqpNameTypeList.length <= 13) {
            this.scrollTypeList = this.allEqpNameTypeList.concat(this.allEqpNameTypeList);
          } else if (this.allEqpNameTypeList.length > 26) {
            this.scrollTypeList = this.allEqpNameTypeList.slice(0, 26);
          } else {
            this.scrollTypeList = this.allEqpNameTypeList;
          }

          // 获取第一种设备名称各科室的信息
          this.getDeptAssetsDistribute(this.scrollTypeList[0]);

          this.searchTypeList = this.allEqpNameTypeList;
          this.$nextTick(res => {
            this.initScroll();
            this.scrollInitInterval();
          });
        }).catch(err => {

        });
      },
      initScroll() {
        var album = this.$refs.album;
        var imgs = this.$refs.album.children;
        var len = imgs.length;
        var newX, newY, lastX, lastY, minusX, minusY;
        var rotX = 0;
        var rotY = 0;
        var initClientX = '';
        var endClientX = '';
        var _this = this;
        this.time = 0;
        this.unitDeg = 360 / len
        _this.opacityList = [];

        var stepOpacity = 1 / (len / 4);
        for (var i = 0; i < len; i++) {
          if (i <= len / 4) {
            _this.opacityList.push(1 - i * stepOpacity);
          } else if (i >= (len - len / 4)) {
            _this.opacityList.push(1 - (len - i) * stepOpacity);
          } else {
            _this.opacityList.push(0);
          }
        }
        console.log(_this.opacityList, '_this.opacityList');
        this.$nextTick(() => {
          Array.prototype.forEach.call(imgs, (it, i, arr) => {

            var numberPx = _this.fontsize.substring(0, _this.fontsize.length - 2) * 30 + '';
            it.style.transform = `rotateY(${i * _this.unitDeg}deg) translateZ(${numberPx}px)`;
            it.style.opacity = `${_this.opacityList[i]}`;

            // 酷炫动效 start 但是会导致转圈的时候背景图更换比较慢
            // it.style.transition = `1s ${(len - i) * 0.1}s`
            // 酷炫动效 end

            it.onmousedown = this.returnFalse
          })

          album.style.transform = `rotateX(-11deg) rotateY(0deg)`;
          _this.current3DView = 0;

          //   鼠标移动 相册旋转 改变album的transform 的rotateX 和 rotateY的值
          document.getElementsByClassName('typeListView')[0].onmousedown = function (e) { // 鼠标点击事件
            initClientX = e.clientX;
            lastX = e.clientX
            lastY = e.clientY
            this.onmousemove = (e) => { // 鼠标移动事件
              newX = e.clientX
              newY = e.clientY

              // 假设 并求值 两次鼠标移动的差值就是移动的距离 和相册旋转的角度成正比
              minusX = newX - lastX
              minusY = newY - lastY

              // rotX += minusY
              // rotY += minusX
              // album.style.transform = `rotateX(${-rotX * 0.2}deg) rotateY(${rotY * 0.2}deg)`
              // album.style.transform = `rotateX(-20deg) rotateY(${rotY * 0.2}deg)`

              // 新的值用完之后就成了旧的值
              lastX = newX
              lastY = newY
            }
            this.onmouseup = (e) => { // 鼠标松开事件
              _this.isAll = false;
              endClientX = e.clientX;
              if (Math.abs(initClientX - endClientX) < 5) {
                // 点击事件
              } else {
                minusX > 0 ? _this.time++ : _this.time--;
                // console.log(_this.unitDeg,'_this.unitDeg');
                // console.log(_this.time,'_this.time');
                // console.log(_this.unitDeg * _this.time,'_this.unitDeg * _this.time1111');
                album.style.transform = `rotateX(-11deg) rotateY(${_this.unitDeg * _this.time}deg)`;
                if (minusX > 0) {
                  _this.current3DView == 0 ? _this.current3DView = len - 1 : _this.current3DView--;
                  _this.opacityList = _this.opacityList.slice(1, _this.opacityList.length).concat(_this.opacityList[0]);
                } else {
                  _this.current3DView == len - 1 ? _this.current3DView = 0 : _this.current3DView++;
                  _this.opacityList = _this.opacityList.slice(_this.opacityList.length - 1, _this.opacityList.length).concat(_this.opacityList.slice(0, _this.opacityList.length - 1));
                }
                // console.log(_this.opacityList, 'opacityListopacityList');
                Array.prototype.forEach.call(imgs, (it, i, arr) => {
                  it.style.opacity = `${_this.opacityList[i]}`;
                })
              }
              this.onmousemove = null;
            }
          }
        })
      },
      scrollInitInterval() {
        var album = this.$refs.album;
        var imgs = this.$refs.album.children;
        var len = imgs.length;
        clearInterval(this.scrollInterval);
        this.scrollInterval = setInterval(() => {
          this.time--;
          this.current3DView == len - 1 ? this.current3DView = 0 : this.current3DView++;
          album.style.transform = `rotateX(-11deg) rotateY(${this.unitDeg * this.time}deg)`;
          this.opacityList = this.opacityList.slice(this.opacityList.length - 1, this.opacityList.length).concat(this.opacityList.slice(0, this.opacityList.length - 1));
          Array.prototype.forEach.call(imgs, (it, i, arr) => {
            it.style.opacity = `${this.opacityList[i]}`;
          })
          this.getRealBorrowRecordQuery();
        }, 3000)
      },
      mousemoveView() {
        // alert("鼠标进入");
        clearInterval(this.scrollInterval);
      },
      toggleBKBg() {
        var now = new Date()
        var hour = now.getHours()
          //999999999999
        if (19 > hour && hour > 6) {
          this.biankuangBg = 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/biankuang.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=1001753349410&Signature=I2HW2vTVaU22Pv6YKyV9rHiijsQ%3D'
        } else {
          this.biankuangBg = 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/biankuang_black.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=1001753349428&Signature=PRV1wv5N6qPqeqWnv2k70UcKEnY%3D'
        }
        clearInterval(this.bgTimeInterval);
        this.bgTimeInterval = setInterval(() => {
          var now = new Date()
          var hour = now.getHours()
          if (19 > hour && hour > 6) {
            this.biankuangBg = 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/biankuang.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=1001753349410&Signature=I2HW2vTVaU22Pv6YKyV9rHiijsQ%3D'
          } else {
            this.biankuangBg = 'https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/biankuang_black.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=1001753349428&Signature=PRV1wv5N6qPqeqWnv2k70UcKEnY%3D'
          }
        }, 3600000)

      },
      // 获取各科室设备分布状况
      getDeptAssetsDistribute(name) {
        var reqData = {
          assetsName: !name ? '' : name
        };
        deptAssetsDistribute(reqData).then(res => {
          this.officeList = res;
        }).catch(err => {

        });
      },
      // 共享设备总数
      getAssetsTotal() {
        assetsTotal({}).then(res => {
          this.shareEqpSum = res.allCount;
          this.overView.freeNum = res.freeCount * 0.01;
          this.overView.lendNum = res.usingCount * 0.01;
          this.overView.faultNum = res.faultCount * 0.01;
        }).catch(err => {

        })
      },
      // 共享设备按名统计
      getAssetsNameTotal() {
        assetsNameTotal({}).then(res => {
          this.rankingShareEqpList = res;
          this.$refs.shareRankingViewScroll.ScrollUp();
        })
      },
      // 设备使用时间排行
      getAssetsUseTimeRank() {
        assetsUseTimeRank({}).then(res => {
          this.rankingViewList = res;
          this.$refs.rankingViewScroll.ScrollUp();
        }).catch(err => {

        });
      },
      //跳转到设备管理
      toAssetsManage(item) {
        console.log(item, 'item');
        if(item.deptId){
          this.$router.push({path: '/assets-management', query: {assetsName: item.assetsName,currentLocationDeptId : item.deptId}});
          this.$store.dispatch('setCurretTitle', '共享设备管理');
        }else{
          this.$router.push({path: '/assets-management', query: {assetsName: item.assetsName}});
          this.$store.dispatch('setCurretTitle', '共享设备管理');
        }
      },
      //跳转到共享记录
      toRecordQuery(item) {
        console.log(item, 'item');
        this.$router.push({path: '/record-query', query: {assetsName: item.assetsName}});
        this.$store.dispatch('setCurretTitle','共享记录查询');
      },
    },
    mounted() {
      window.onresize = () => {
        return (() => {
          var elem = document.getElementById("areaCockpit");
          if (!elem) {

          } else {
            console.log("屏幕变化大小");
            this.resizePage();
          }
        })();
      };
      this.resizePage();

      // animated增加动效
      // document.getElementsByClassName('bottom_left')[0].className = ('bottom_left animated fadeInLeftBig');
      // document.getElementsByClassName('bottom_right')[0].className = ('bottom_right animated fadeInRightBig');
    },
    created() {
      this.timeStr = getTime();
      this.toggleBKBg();
    },
    destroyed() {
      console.log("=========================清除计时器=====================");
      clearInterval(this.scrollInterval);
    }
  }
</script>
<style scoped>
    @import '../../styles/animate.min.css';

    div {
        box-sizing: border-box;
    }

    .bgView {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/containBg.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=1001753349462&Signature=A28IyekkfJ6JYPC4URKGYDrKhEQ%3D');
        background-size: cover;
        background-position: center;
        color: #fff;
        font-size: 1em;
    }

    .bg {
        width: 100%;
        height: 100%;
        display: flex;
        /*align-items: center;*/
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-size: 100% 100%;
        background-position: center;
    }

    .bk {
        width: 100%;
        height: 100%;
        display: flex;
        /*align-items: center;*/
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-image: url('https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/containBg.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753350258&Signature=8%2BkqbP5XsBYGiY6qrRIiRutvtZY%3D');
        background-size: cover;
        background-position: center;
        color: #fff;
    }

    .containerView {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-size: 100% 100%;
        background-position: center;
    }

    .bottomDiv {
        width: 100%;
        height: 84%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
    }

    .bottom_left {
        /*position: absolute;*/
        /*z-index: 2;*/
        /*left: 3%;*/
        /*top: 10%;*/
        height: 100%;
        width: 21%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        /*background-color:pink;*/
    }

    .bottom_right {
        width: 21%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        /*background-color: orange;*/
    }

    .bottom_center {
        width: 53%;
        margin-left: 1%;
        margin-right: 1%;
        /*position: relative;*/
        /*width: 100%;*/
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        position: relative;
    }

    .bottom_center_bg {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 0;
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }

    .bottom_center_bg > img {
        width: 65em;
    }

    @keyframes rotateFrame {
        0% {
            transform: rotate(0);
        }

        50% {
            transform: rotate(-180deg);
        }

        100% {
            transform: rotate(-360deg);
        }
    }

    .serviceTj > div {
        margin: 0 15%;
    }

    .waitRpaireTable > div {
        width: 13%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .teamRpaireTable > div {
        width: 11%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .teamRpaireTable > div:nth-child(6) {
        width: 16%;
    }

    .teamRpaireTable > div:nth-child(8) {
        width: 16%;
    }

    .workMonitoringItem_left > div:nth-child(1) {
        /*font-size:1.25em;*/
        margin-bottom: 0.87rem;
    }

    .workMonitoringItem_left > div:nth-child(2) {
        margin-bottom: 0.87rem;
    }

    .operationView {
        /*position: absolute;*/
        /*left: 0;*/
        /*top: 4%;*/
        height: 5%;
        width: 100%;
        padding: 0 4%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1%;
    }

    @keyframes rotateFrame {
        0% {
            transform: rotate(0);
        }

        50% {
            transform: rotate(-180deg);
        }

        100% {
            transform: rotate(-360deg);
        }
    }

    .stateNum > span {
        font-size: 1rem;
    }

    .helloView {
        width: 11em;
        height: 100%;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/hello.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=1001753349523&Signature=u8xjsB%2B2l8qyOeQA82YjIk5Thkk%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        margin-right: 0.2em;
    }

    .c-pointer {
        cursor: pointer;
    }

    .workBench {
        width: 12em;
        height: 100%;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/gztf.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=1001753349546&Signature=1pdSoQM3qwfEL2JB%2Fnah4nINHOQ%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
    }

    .entranceView {
        width: 13em;
        height: 3em;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/ssk.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=1001753349570&Signature=LVMjPRf0%2BAHKUTVjzxqAkpTdySs%3D");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        margin-right: 0.2em;
    }

    .chooseTypeView {
        width: 20em;
        height: 3em;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/typeSelectView.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349593&Signature=NqO4dsI2Ym2zQhLzwHtHQK9tWBo%3D");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        margin-right: 0.2em;
        padding-left: 5em;
        position: relative;
        /*right: -4em;*/
    }

    .scrollItem {
        padding-bottom: 0.5em;
        border-bottom: 1px solid rgba(96, 212, 230, 0.4);
        line-height: 2em;
        margin-bottom: 1em;
    }

    .setUpView {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    ::-webkit-input-placeholder {
        color: #fff;
        font-style: italic;
        font-weight: bolder;
    }

    .typeListView {
        position: absolute;
        bottom: 1em;
        height: 20%;
        background: transparent;
        perspective: 4000px;
        width: 100%;
        cursor: pointer;
    }

    /*场景景深*/
    .typeListView:before {
        content: "";
        display: table;
    }

    .album {
        width: 5em;
        height: 5em;
        word-break: break-all;
        /*background-color: red;*/
        /*border: solid 1px red;*/
        margin: 0em auto;
        position: relative;
        transform-style: preserve-3d;
        transform: rotateX(-11deg) rotateY(0deg) rotateZ(0deg);
        transition: transform 0.5s linear;
    }

    /*设置场景风格*/

    .album div {
        position: absolute;
        /*-webkit-box-reflect: below 5px -webkit-linear-gradient(top,rgba(250,250,250,0),rgba(250,250,250,.0) 30%,rgba(250,250,250,0.3));*/
    }

    .shareEqpSum {
        width: 100%;
        height: 13%;
        padding-left: 1.5em;
        padding-right: 1.5em;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/gailan.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349636&Signature=kik0y%2F6z0fR1GzP0otGViOUb5Yc%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
    }

    .rankingView {
        width: 100%;
        height: 48%;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/sbgxph.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349661&Signature=VyXSkafau0n%2F%2FxymOCnLONWwPZQ%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        padding: 1.5em 1.5em 1.5em 1.5em;
    }

    .timeRankingView {
        width: 100%;
        height: 36%;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/zcsysjph.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349681&Signature=MvmaXXhEiboZG%2BC4lJKotPJyGOw%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        padding: 1.5em 1.5em 1.5em 1.5em;
    }

    .indexViewStyle {
        padding: 0.2em 0.5em;
        background-image: linear-gradient(to right, #01BBF7, #0187E7);
        margin-right: 0.5em;
    }

    .overdueView {
        width: 100%;
        height: 47%;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/yqwgh.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349706&Signature=KiWWYTbl7XbAsAE674oi%2FKDG0KU%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        padding: 1.5em 2em 1.5em 2em;
    }

    .titleStyle {
        font-weight: bold;
        font-size: 1.2em;
    }

    .realTimeView {
        width: 100%;
        height: 50%;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/ssjcjl.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349729&Signature=gSGaa%2FXjf1VGfDwEYCHlvFsPpQE%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        padding: 1.5em 2em 1.5em 2em;
    }

    .keyTimeView {
        width: 8em;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/keyWordBg.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349751&Signature=Xwqk80KNxDBxmo95ElcjPGhNduQ%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
    }

    .overdueNum {
        color: #00D2FF;
        width: 40%;
        padding: 0.2em 1em;
        /*border:1px solid #00D2FF;*/
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/wghs.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349771&Signature=80T66S%2FcIPeKtGSFlewqwbKlWqc%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
    }

    .officeShowView {
        width: 100%;
        height: 80%;
    }

    .officeItem {
        width: 14em;
        height: 12em;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/jzk.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349789&Signature=bo1XOtUD%2FITHsGnfoevO5jrCLS0%3D");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: bottom;
        position: relative;
        margin: auto;
        margin-bottom: 2.8em;
    }

    .officeItem_topLeft {
        font-size: 1em;
        position: absolute;
        top: 0;
        left: 0;
        transform: rotate(-30deg) translateY(1em) skew(-15deg);
    }

    .officeItem_topRight {
        position: absolute;
        top: 0;
        right: 0;
        transform: rotate(30deg) translateY(1.5em) skew(25deg)
    }

    .officeItem_bottom {
        position: absolute;
        bottom: -0.6em;
        left: 0;
        width: 100%;
    }

    .numView {
        width: 3.5em;
        height: 3.8em;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/kxlbx.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349813&Signature=vlsPAaur6CWrMFnjzZn2RVro7bA%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        font-size: 0.8em;
    }

    .lend {
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/jcdbx.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349832&Signature=O4k0mnw8oVYwQtZ165kyDtCIHDA%3D");
    }

    .fault {
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/gzdbx.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349851&Signature=WNszXUBKxxPDHqs%2Bsm9%2F9BedmsQ%3D");
    }

    .rankingViewItem {
        background-color: rgba(54, 69, 93, 0.77);
        border: none;
        margin-bottom: 1px;
        padding: 0.5em 0.5em;
    }

    .scroll3dView {
        width: 8em;
        height: 6.5em;
        position: absolute;
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/lbx.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349875&Signature=e5lIBoj76mUMO4W5rkhI3u1mSN8%3D");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        transition: width 0.5s linear;
        transition: height 0.5s linear;
        padding:0 1em;
        /*background-color:pink;*/
        text-align: center;
    }

    .scroll3dViewCurrent {
        background-image: url("https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/share-web/lbx2.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=100001753349897&Signature=uJPuanjNADhHEWplDzYdvK2PraU%3D");
        width: 9em;
        height: 7em;
    }

    .listView::-webkit-scrollbar {
        width: 6px;
        background-color: #fff;
    }

    .listView::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
    }

    .listView::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
    }

    .selectEqpNameClass {
        width: 6em;
        font-size: 1em;
        font-weight: bold;
        height: 100%;
        color: #fff;
        outline: none;
    }
</style>
